import { render, staticRenderFns } from "./Viivhealthcare.vue?vue&type=template&id=6ed19abe&scoped=true"
import script from "./Viivhealthcare.vue?vue&type=script&lang=js"
export * from "./Viivhealthcare.vue?vue&type=script&lang=js"
import style0 from "./Viivhealthcare.vue?vue&type=style&index=0&id=6ed19abe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed19abe",
  null
  
)

export default component.exports